import type { EprCategoryCode } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'

export const EPR_CATEGORIES: Record<EprCategoryCode, EprCategoryCode> = {
  BATTERIES: 'BATTERIES',
  DEEE: 'DEEE',
  PACKAGING: 'PACKAGING',
  PAPER: 'PAPER',
  OTHER: 'OTHER',
} as const
